import React from 'react';
import './AboutView.css';
import picoImg from '../../images/pico.jpg';

const AboutView = ({ onDogClick }) => (
    <div className="about-view">
        <div className="about-view__content">
            <section className="about-view__section">
                <h2 className="about-view__heading">Hey! Delunado here.</h2>
                <p className="about-view__text">
                    I'm a <b>software engineer</b> and <b>game developer</b> based in the south of Spain. I've been making games for 8~ years, since
                    2018, working on everything from <b>tiny jam prototypes</b> to <b>shipped Steam and console titles</b>.
                    I'm a lover of <b>incremental games</b>, but have also worked on <b>puzzle games</b>, <b>VR</b>, <b>simulation-y games</b> and more. 
                    In the end, <b>I just like making games</b>
                </p>
                <p className="about-view__text">
                    By day I <b>co-run <a href="https://store.steampowered.com/app/3503440/Astro_Prospector/" target="_blank" rel="noopener noreferrer">Incrementalist</a></b>,
                    an indie studio focused on quality incremental experiences, with <b>140.000+ copies sold</b> of our games. I also <b>created the
                    <a href="https://t.me/spaingamedevs" target="_blank" rel="noopener noreferrer"> Spain Game Devs</a></b> community a few years ago, a big group of Spanish
                    game developers, organizing Jams & connecting developers with each other.
                </p>
            </section>

            <div className="about-view__body">
                <div className="about-view__text-sections">
                    <section className="about-view__section">
                        <h3 className="about-view__subheading">What I do</h3>
                        <ul className="about-view__list">
                            <li>Game design & game programming, mainly with Unity & C#</li>
                            <li>Deep focus on incremental game design & systems</li>
                            <li>Community building & jams organization (up to 800 participants!)</li>
                            <li>Talks, workshops and mentorship about game development</li>
                        </ul>
                    </section>

                    <section className="about-view__section">
                        <h3 className="about-view__subheading">What I love</h3>
                        <ul className="about-view__list">
                            <li>Working on well-organized, truly agile teams.</li>
                            <li>Reading philosophy and software non-fiction books.</li>
                            <li>Tinkering with systems & game design, both software and table games.</li>
                            <li>Living in peace and tranquility. Probably my favorite 🤓</li>
                        </ul>
                    </section>

                    <section className="about-view__section">
                        <h3 className="about-view__subheading">Find me</h3>
                        <ul className="about-view__links">
                            <li><a href="/blog">Blog</a> — thoughts on gamedev, process, and more</li>
                            <li><a href="https://delunado.itch.io" target="_blank" rel="noopener noreferrer">itch.io</a> — free jam games</li>
                            <li><a href="mailto:delunadogames@gmail.com">delunadogames@gmail.com</a> — say hi</li>
                        </ul>
                    </section>
                </div>

                <div className="about-view__dog-wrapper">
                    <div className="about-view__dog-placeholder" onClick={onDogClick}>
                        <img src={picoImg} alt="Pico" className="about-view__dog-img" />
                    </div>
                    <p className="about-view__dog-caption">I also have a lovely giant dog named Pico!</p>
                </div>
            </div>
        </div>
    </div>
);

export default AboutView;
